import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useLoaderStore, useUserStore } from "../context";
import { useAlert, useApi } from "../hooks";
import constants from "../utils/constants";
import { isInvalidID, switchSortDirection } from "../utils/helpers";
import { ActiveFilter, PrimaryTable } from "../components/Tables";
import dateHelpers from "../utils/dateHelpers";

const EMPTY_FILTERS = {
  activeOnly: false,
};

export default function APIActivities({systemTenantId}) {
  const navigate = useNavigate();
  const alert = useAlert();
  const { fetch } = useApi();
  
  //Activity Variables
  const [isLoading, setIsLoading] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    ...EMPTY_FILTERS,
    activeOnly: true,
  });
  // const [stagedFilters, setStagedFilters] = useState(activeFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortDirection, setSortDirection] = useState(
    constants.SORT_DIRECTIONS.DESCENDING
  );
  const [sortField, setSortField] = useState("initiatedAt");
  const [displayCount, setDisplayCount] = useState(
    constants.DISPLAY_PER_PAGE ?? 25
  );
  const [activities, setActivities] = useState({ list: [], totalCount: 0 });

  useEffect(() => {
    if (isInvalidID(systemTenantId)) return;
    getActivityList();
  }, [currentPage, displayCount, activeFilters, sortDirection, sortField]);

  const getActivityList = () => {
    setIsLoading(true);
    fetch("admin/ApiOperationsList", {
      pageNumber: currentPage,
      pageSize: displayCount,
      sortDirection: sortDirection,
      sortField: sortField,
      isExact: false,
      systemTenantId: systemTenantId,
      ...activeFilters,
    })
      .then((res) => {
        setActivities(res);
      })
      .catch((err) => {
        alert("Server error", "Could not retrieve products", "error");
      })
      .finally(() => setIsLoading(false));
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(switchSortDirection(sortDirection));
    } else {
      setSortField(field);
    }
  };

  if (!systemTenantId) return null;
  return (
    <div className="bg-gray-100 shadow-md rounded-md shadow-primaryColor/25">
      <PrimaryTable
        isLoading={isLoading}
        totalCount={activities?.totalCount}
        displayCount={displayCount}
        currentPage={currentPage}
        setDisplayCount={setDisplayCount}
        setCurrentPage={setCurrentPage}
        header={
          <PrimaryTable.Header>
            <PrimaryTable.HeaderColumn
              display="Id"
              // onSort={() => handleSort("id")}
              isSortingBy={sortField === "id"}
              sortDirection={sortDirection}
            />
            <PrimaryTable.HeaderColumn
              display="Http Method"
            />
            <PrimaryTable.HeaderColumn
              display="Uri"
              onSort={() => handleSort("uri")}
              isSortingBy={sortField === "uri"}
              sortDirection={sortDirection}
            />
            <PrimaryTable.HeaderColumn
              display="Initiated At"
              onSort={() => handleSort("initiatedAt")}
              isSortingBy={sortField === "initiatedAt"}
              sortDirection={sortDirection}
            />
            <PrimaryTable.HeaderColumn
              display="Completed At"
              onSort={() => handleSort("completedAt")}
              isSortingBy={sortField === "completedAt"}
              sortDirection={sortDirection}
            />
          </PrimaryTable.Header>
        }
      >
        {activities &&
          activities.list &&
          activities.list.map((x, i) => (
            <PrimaryTable.Row
              key={`${x.id}-${i}`}
              index={i}
              onClick={(e) => {
                if (!x.deactivatedAt) {
                  navigate(`/activity/${systemTenantId}/${x.id}`);
                }
              }}
            >
              <PrimaryTable.Cell>
                {x.id}
              </PrimaryTable.Cell>
              <PrimaryTable.Cell>
                {x.httpMethod}
              </PrimaryTable.Cell>
              <PrimaryTable.Cell>
                {x.operationUri}
              </PrimaryTable.Cell>
              <PrimaryTable.Cell>
                {dateHelpers.localDateTime(x.initiatedAt, dateHelpers.YMDHMSA)}
              </PrimaryTable.Cell>
              <PrimaryTable.Cell>
                {dateHelpers.localDateTime(x.completedAt, dateHelpers.YMDHMSA)}
              </PrimaryTable.Cell>
        </PrimaryTable.Row>
      ))}
      </PrimaryTable>
    </div>
  );
}
